import * as dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isToday from "dayjs/plugin/isToday";
import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const useFilter = (data, itemsPerPage) => {
  const prevDataRef = useRef([]);
  const [billdetailspayment, setBilldetailspayment] = useState("");
  const [filter, setFilter] = useState("");
  const [sortedField, setSortedField] = useState("");
  const [searchUser, setSearchUser] = useState("");
  const [vendor, setVendor] = useState("");
  const [vendorRequest, setVendorRequest] = useState("");
  const [cityVendorRequest, setCityVendorRequest] = useState("");
  const [vehicleCategory, setVehicleCategory] = useState("");
  const [vehicletype, setVehicletype] = useState("");
  const [hourbasic, setHourBasic] = useState("");
  const [itinerarybasic, setItineraryBasic] = useState("");
  const [itineraryperiodic, setItineraryPeriodic] = useState("");
  const [seoManageCity, setSeoManageCity] = useState("");
  const [seoPage, setSeoPage] = useState("");
  const [topselling, setTopselling] = useState("");
  const [booking, setBooking] = useState("");
  const [vehicle, setVehicle] = useState("");
  const [advertisement, setAdvertisement] = useState("");
  const [contact, setContact] = useState("");
  const [career, setCareer] = useState("");
  const [languagedriver, setLanguageDriver] = useState("");
  const [menu, setMenu] = useState("");
  const [razorpaydetails, setRazorpayDetails] = useState("");
  const [razorpayorderdetails, setRazorpayOrderDetails] = useState("");
  const [clientfeedback, setClientFeedback] = useState("");
  const [permit, setPermit] = useState("");
  const [partialpayment, setPartialPayment] = useState("");
  const [subusers, setSubusers] = useState("");
  const [billpaymentreport, setBillPaymentReport] = useState("");
  const [tripadvance, setTripadvance] = useState("");
  const [tripadvancepayment, setTripadvancePayment] = useState("");
  const [paymentdetails, setPaymentDetails] = useState("");
  const [jobtitle, setJobtitle] = useState("");
  const [vendorAllot, setVendorAlot] = useState("");
  const [franchiseSearch, setFranchiseSearch] = useState("");
  const [franchiseAllotSearch, setFranchiseAlotSearch] = useState("");
  const [subscribe, setSubscribe] = useState("");
  const [hourPeriodicday, setHourPeriodicDay] = useState("");
  const [hourPeriodictime, setHourPeriodicTime] = useState("");
  const [daybasic, setDayBasic] = useState("");
  const [agent, setAgent] = useState("");
  const [vehicleAllot, setVehicleAllot] = useState("");
  const [sold, setSold] = useState("");
  const [soldAir, setSoldAir] = useState("");
  const [airbasic, setAirBasic] = useState("");
  const [onewaybasic, setonewaybasic] = useState("");
  const [onewayHikeday, setonewayHikeday] = useState("");
  const [airPeriodicday, setAirPeriodicDay] = useState("");
  const [airPeriodictime, setAirPeriodicTime] = useState("");
  const [OnewayPeriodicTime, setOnewayPeriodicTime] = useState("");
  const [dayperiodic, setDayPeriodic] = useState("");
  const [vehicleModel, setVehicleModel] = useState("");
  const [vehicleBrand, setVehicleBrand] = useState("");
  const [vehicleSeats, setVehicleSeats] = useState("");
  const [vehicleColor, setVehicleColor] = useState("");
  const [driver, setDriver] = useState("");
  const [purchasebill, setPurchaseBill] = useState("");
  const [driverqueue, setDriverqueue] = useState("");
  const [country, setCountry] = useState("");
  const [zone, setZone] = useState("");
  const [pending, setPending] = useState([]);
  const [processing, setProcessing] = useState([]);
  const [delivered, setDelivered] = useState([]);
  const [status, setStatus] = useState("");
  const [time, setTime] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [dataTable, setDataTable] = useState([]); //tableTable for showing on table according to filtering
  const [todayOrder, setTodayOrder] = useState("");
  const [monthlyOrder, setMonthlyOrder] = useState("");
  const [totalOrder, setTotalOrder] = useState("");
  const [billapproval, setBillApproval] = useState("");
  const [sales, setSales] = useState("");
  const [revenueReport, setRevenueReport] = useState("");
  const [parking, setParking] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [seoVirtual, setSeoVirtual] = useState("");
  const [News, setNews] = useState("");
  const [minDuration, setminDuration] = useState("");

  const [isDisabled] = useState(false);
  const [newProducts] = useState([]);
  const currencyRef = useRef("");
  const bookingRef = useRef("");
  const driverRef = useRef("");
  const billRef = useRef("");
  const vendoralotRef = useRef("");
  const franchisealotRef = useRef("");
  const franchiseRef = useRef("");
  const driverqueueRef = useRef("");
  const vehicleRef = useRef("");
  const advertisementRef = useRef("");
  const contactRef = useRef("");
  const careerRef = useRef("");
  const languagedriverRef = useRef("");
  const menuRef = useRef("");
  const razorpaydetailsRef = useRef("");
  const razorpayorderdetailsRef = useRef("");
  const clientfeedbackRef = useRef("");
  const permitRef = useRef("");
  const partialpaymentRef = useRef("");
  const subusersRef = useRef("");
  const billpaymentreportRef = useRef("");
  const tripadvanceRef = useRef("");
  const tripadvancepaymentRef = useRef("");
  const soldRef = useRef("");
  const soldAirportRef = useRef("");
  const paymentdetailsRef = useRef("");
  const jobtitleRef = useRef("");
  const subscribeRef = useRef("");
  const SeoManageCityRef = useRef("");
  const seoPageRef = useRef("");
  const searchRef = useRef("");
  const userRef = useRef("");
  const vehicleCategoryRef = useRef("");
  const vehicleTypeRef = useRef("");
  const fixedItineraryRef = useRef("");
  const fixedItineraryPeriodicHikeRef = useRef("");
  const topSellingRef = useRef("");
  const hourRentalBasicRateRef = useRef("");
  const dayRentalBasicRateRef = useRef("");
  const agentsRef = useRef("");
  const airportPickupBasicRateRef = useRef("");
  const airportPickupPeriodicHikeDayRef = useRef("");
  const airportPickupPeriodicHikeTimeRef = useRef("");
  const dayRentalPeriodicHikeDayRef = useRef("");
  const hourRentalPeriodicHikeDayRef = useRef("");
  const hourRentalPeriodicHikeTimeRef = useRef("");
  const vendorRef = useRef("");
  const vendorRequestRef = useRef("");
  const cityVendorRequestRef = useRef("");
  const onewayPickupBasicRateRef = useRef("");
  const onewayPickupHideDayRef = useRef("");
  const onewayPickupPeriodicHikeTimeRef = useRef("");
  const channelPartnerListref = useRef("");
  const newsRef = useRef("");
  const minDurationRef = useRef("");
  const vehicleModelRef = useRef("");
  const vehicleBrandRef = useRef("");
  const vehicleSeatsRef = useRef("");
  const vehicleColorRef = useRef("");
  const couponRef = useRef("");
  const orderRef = useRef("");
  const categoryRef = useRef("");
  const attributeRef = useRef("");
  const countryRef = useRef("");
  const languageRef = useRef("");
  const taxRef = useRef("");
  const billapprovalRef = useRef("");
  const billdetailspaymentRef = useRef("");
  const vehicleAllotRef = useRef("");
  const SalesRef = useRef("");
  const RevenueReportRef = useRef("");
  const ParkingRef = useRef("");
  const WhatsappRef = useRef("");
  const seoVirtualRef = useRef("");
  dayjs.extend(isBetween);
  dayjs.extend(isToday);
  const location = useLocation();
  //service data filtering
  const serviceData = useMemo(() => {
    const date = new Date();
    date.setDate(date.getDate() - time);

    if (location.pathname === "/dashboard") {
      const orderPending = data?.filter(
        (statusP) => statusP.status === "Pending",
      );
      setPending(orderPending);
      const orderProcessing = data?.filter(
        (statusO) => statusO.status === "Processing",
      );
      setProcessing(orderProcessing);
      const orderDelivered = data?.filter(
        (statusD) => statusD.status === "Delivered",
      );
      setDelivered(orderDelivered);
      //daily total order calculation
      const todayServices = data?.filter((order) =>
        dayjs(order.createdAt).isToday(),
      );
      const todayOrder = todayServices?.reduce(
        (preValue, currentValue) => preValue + currentValue.total,
        0,
      );
      setTodayOrder(todayOrder);
      //monthly order calculation
      const monthlyServices = data?.filter((order) =>
        dayjs(order.createdAt).isBetween(
          new Date().setDate(new Date().getDate() - 30),
          new Date(),
        ),
      );
      const monthlyOrder = monthlyServices?.reduce(
        (preValue, currentValue) => preValue + currentValue.total,
        0,
      );
      setMonthlyOrder(monthlyOrder);
      //total order calculation
      const totalOrder = data?.reduce(
        (preValue, currentValue) => preValue + currentValue.total,
        0,
      );
      setTotalOrder(totalOrder);
    }
    if (searchUser) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      data = data.filter(
        (search) =>
          search?.Reference?.toLowerCase().includes(searchUser.toLowerCase()) ||
          search?.Customer?.toLowerCase().includes(searchUser.toLowerCase()) ||
          search?.Mobile?.toLowerCase().includes(searchUser.toLowerCase()) ||
          search?.Email?.toLowerCase().includes(searchUser.toLowerCase()) ||
          search?.City?.toLowerCase().includes(searchUser.toLowerCase()) ||
          search?.Status?.toLowerCase().includes(searchUser.toLowerCase()) ||
          (search
            ? search["Login By"]
                .toLowerCase()
                .includes(searchUser.toLowerCase())
            : false) ||
          (search
            ? search["Created Date"]
                .toLowerCase()
                .includes(searchUser.toLowerCase())
            : false),
      );
    }

    if (sold) {
      const searchTerms = sold.toLowerCase().split(" ");

      data = data.filter((search) => {
        return searchTerms.every(
          (term) =>
            search?.city_name?.toLowerCase().includes(term) ||
            search?.start_date?.toString().includes(term) ||
            search?.end_date?.toString().includes(term),
        );
      });
    }
    if (soldAir) {
      const searchTerms = soldAir.toLowerCase().split(" ");

      data = data.filter((search) => {
        return searchTerms.every(
          (term) =>
            search?.airport_name?.toLowerCase().includes(term) ||
            search?.start_date?.toString().includes(term) ||
            search?.end_date?.toString().includes(term),
        );
      });
    }

    if (vehicleCategory) {
      const searchTerms = vehicleCategory.toLowerCase().split(" ");

      const amenitiesMapping = {
        1: "AC",
        2: "Charger",
        3: "Music",
        4: "Carrier",
        5: "TV",
      };

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.seats && search.seats.toLowerCase().includes(term)) ||
            (search?.similar_vehicle &&
              search.similar_vehicle.toLowerCase().includes(term)) ||
            (search?.vehicle_type_name &&
              search.vehicle_type_name.toLowerCase().includes(term)) ||
            (search?.amenities &&
              search.amenities.some((amenity) =>
                amenitiesMapping[amenity]?.toLowerCase().includes(term),
              )),
        );
      }, data);
    }

    if (vehicletype) {
      data = data.filter((search) =>
        search
          ? search["name"].toLowerCase().includes(vehicletype.toLowerCase())
          : false,
      );
    }

    if (vehicleAllot) {
      const searchTerms = vehicleAllot.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.company_name &&
              search.company_name.toLowerCase().includes(term)) ||
            (search?.client_name &&
              search.client_name.toLowerCase().includes(term)) ||
            (search?.ref_no && search.ref_no.toLowerCase().includes(term)) ||
            (search?.vehicle_reg_no &&
              search.vehicle_reg_no.toLowerCase().includes(term)) ||
            (search?.vehiclename &&
              search.vehiclename.toLowerCase().includes(term)) ||
            (search?.driver_name &&
              search.driver_name.toLowerCase().includes(term)) ||
            (search?.driver_contact_no &&
              search.driver_contact_no.toLowerCase().includes(term)) ||
            (search?.start_date &&
              search.start_date.toLowerCase().includes(term)) ||
            (search?.end_date && search.end_date.toLowerCase().includes(term)),
        );
      }, data);
    }
    if (vendorAllot) {
      const searchTerms = vendorAllot.toLowerCase().trim().split(/\s+/);

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => {
          const presentAllotment = search?.allotment_history?.find(
            (i) => i?.status === "Present",
          );

          return (
            (search?.ref_no && search.ref_no.toLowerCase().includes(term)) ||
            (search?.client_name &&
              search.client_name.toLowerCase().includes(term)) ||
            (search?.departure_name &&
              search.departure_name.toLowerCase().includes(term)) ||
            (search?.arrival_name &&
              search.arrival_name.toLowerCase().includes(term)) ||
            (search?.package_type &&
              search.package_type.toLowerCase().includes(term)) ||
            // Vendor from Present allotment
            (presentAllotment?.vendor_name &&
              presentAllotment.vendor_name.toLowerCase().includes(term)) ||
            // Franchise from Present allotment
            (presentAllotment?.franchise_name &&
              presentAllotment.franchise_name.toLowerCase().includes(term)) ||
            (search?.vehiclename &&
              search.vehiclename.toLowerCase().includes(term)) ||
            (search?.start_date &&
              search.start_date.toLowerCase().includes(term)) ||
            (search?.end_date &&
              search.end_date.toLowerCase().includes(term)) ||
            (search?.vendor_status &&
              search.vendor_status.toLowerCase().includes(term))
          );
        });
      }, data);
    }
    if (hourbasic) {
      const searchTerms = hourbasic.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.city && search.city.toLowerCase().includes(term)) ||
            (search?.vehicle_type_id &&
              search.vehicle_type_id.some((id) => {
                const typeName = search.vehicle_type_names[id];
                const prime = search.prime[id];
                const km4h40 = search["4h_40km"]?.[id]
                  ?.toString()
                  .toLowerCase();
                const km6h60 = search["6h_60km"]?.[id]
                  ?.toString()
                  .toLowerCase();
                const km8h80 = search["8h_80km"]?.[id]
                  ?.toString()
                  .toLowerCase();
                const km10h100 = search["10h_100km"]?.[id]
                  ?.toString()
                  .toLowerCase();
                const extraKm = search["extra_km"]?.[id]
                  ?.toString()
                  .toLowerCase();
                const extraHr = search["extra_hr"]?.[id]
                  ?.toString()
                  .toLowerCase();
                return (
                  (typeName && typeName.toLowerCase().includes(term)) ||
                  (prime && prime.toString().toLowerCase().includes(term)) ||
                  (km4h40 && km4h40.includes(term)) ||
                  (km6h60 && km6h60.includes(term)) ||
                  (km8h80 && km8h80.includes(term)) ||
                  (km10h100 && km10h100.includes(term)) ||
                  (extraKm && extraKm.includes(term)) ||
                  (extraHr && extraHr.includes(term))
                );
              })),
        );
      }, data);
    }

    if (itinerarybasic) {
      const searchTerms = itinerarybasic.toLowerCase().split(" ");

      data = data.filter((search) => {
        return searchTerms.every(
          (term) =>
            search?.package_code?.toLowerCase().includes(term) ||
            search?.route?.toLowerCase().includes(term),
        );
      });
    }
    if (seoManageCity) {
      const searchTerms = seoManageCity.toLowerCase().split(" ");

      data = data.filter((search) => {
        return searchTerms.every(
          (term) =>
            search?.city_name?.toLowerCase().includes(term) ||
            search?.state_name?.toLowerCase().includes(term) ||
            search?.seo_active?.toString().includes(term) ||
            (term === "active"
              ? search?.seo_active?.toString() === "true"
              : null) ||
            (term === "inactive"
              ? search?.seo_active?.toString() === "false"
              : null),
        );
      });
    }
    if (seoPage) {
      const searchTerms = seoPage.toLowerCase().split(" ");

      data = data.filter((search) => {
        return searchTerms.every(
          (term) =>
            search?.url?.toLowerCase().includes(term) ||
            search?.keywords?.toLowerCase().includes(term) ||
            search?.title?.toLowerCase().includes(term),
        );
      });
    }

    if (topselling) {
      const searchTerms = topselling.toLowerCase().split(" ");

      data = data.filter((search) => {
        return searchTerms.every(
          (term) =>
            search?.package_code?.toLowerCase().includes(term) ||
            search?.route?.toLowerCase().includes(term) ||
            search?.no_of_days?.toString().includes(term) ||
            search?.no_of_nights?.toString().includes(term) ||
            search?.statename?.toLowerCase().includes(term),
        );
      });
    }

    if (booking) {
      const searchTerms = booking.toLowerCase().split(" ");

      data = data.filter((search) => {
        return searchTerms.every(
          (term) =>
            search?.ref_no?.toLowerCase().includes(term) ||
            search?.agentname?.toLowerCase().includes(term) ||
            search?.agentref?.toLowerCase().includes(term) ||
            search?.client_name?.toLowerCase().includes(term) ||
            search?.package_type?.toLowerCase().includes(term) ||
            search?.arrival?.toLowerCase().includes(term) ||
            search?.start_date?.toLowerCase().includes(term) ||
            search?.end_date?.toLowerCase().includes(term) ||
            search?.is_online?.toString().includes(term) ||
            (term.toLowerCase() === "online"
              ? search?.is_online?.toString() === "true"
              : null) ||
            (term.toLowerCase() === "offline"
              ? search?.is_online?.toString() === "false"
              : null),
        );
      });
    }

    if (vehicle) {
      const searchTerms = vehicle.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.vendor_name &&
              search.vendor_name.toLowerCase().includes(term)) ||
            (search?.vehicle_name_id &&
              search.vehicle_name_id.toLowerCase().includes(term)) ||
            (search?.vehicle_reg_no &&
              search.vehicle_reg_no.toLowerCase().includes(term)) ||
            (search?.year_of_vehicle_manufactured &&
              search.year_of_vehicle_manufactured.toLowerCase().includes(term)),
        );
      }, data);
    }
    if (advertisement) {
      const searchTerms = advertisement.toLowerCase().split(" ");
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.title && search.title.toLowerCase().includes(term)) ||
            (search?.url && search.url.toLowerCase().includes(term)) ||
            (search?.content && search.content.toLowerCase().includes(term)),
        );
      }, data);
    }

    if (driver) {
      const searchTerms = driver.toLowerCase().split(" ");

      data = data.filter((search) => {
        return searchTerms.every(
          (term) =>
            search?.ref_no?.toLowerCase().includes(term) ||
            search?.vendor_name?.toLowerCase().includes(term) ||
            search?.driver_name?.toLowerCase().includes(term) ||
            search?.driver_contact_no?.toLowerCase().includes(term) ||
            search?.driving_license?.toLowerCase().includes(term) ||
            search?.city?.toLowerCase().includes(term),
        );
      });
    }

    if (purchasebill) {
      const searchTerms = purchasebill.toLowerCase().split(" ");

      data = data.filter((search) => {
        return searchTerms.every(
          (term) =>
            search?.ref_no?.toLowerCase().includes(term) ||
            search?.vendor_name?.toLowerCase().includes(term) ||
            search?.client_name?.toLowerCase().includes(term) ||
            search?.start_date?.toLowerCase().includes(term) ||
            search?.end_date?.toLowerCase().includes(term),
        );
      });
    }

    if (driverqueue) {
      const searchTerms = driver.toLowerCase().split(" ");
      data = data.filter((search) => {
        return searchTerms.every(
          (term) =>
            search?.ref_no?.toLowerCase().includes(term) ||
            search?.vendor_name?.toLowerCase().includes(term) ||
            search?.driver_name?.toLowerCase().includes(term) ||
            search?.driver_contact_no?.toLowerCase().includes(term) ||
            search?.driving_license?.toLowerCase().includes(term) ||
            search?.city?.toLowerCase().includes(term),
        );
      });
    }

    if (contact) {
      const searchTerms = contact.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.name && search.name.toLowerCase().includes(term)) ||
            (search?.email_id &&
              search.email_id.toLowerCase().includes(term)) ||
            (search?.mobile_no &&
              search.mobile_no.toLowerCase().includes(term)) ||
            (search?.subject && search.subject.toLowerCase().includes(term)),
        );
      }, data);
    }

    if (career) {
      const searchTerms = career.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.name && search.name.toLowerCase().includes(term)) ||
            (search?.job_roles &&
              search.job_roles.toLowerCase().includes(term)) ||
            (search?.total_experience &&
              String(search.total_experience).includes(term)) ||
            (search?.summary && search.summary.toLowerCase().includes(term)),
        );
      }, data);
    }
    if (languagedriver) {
      const searchTerms = languagedriver.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            search?.lang_driver &&
            search.lang_driver.toLowerCase().includes(term),
        );
      }, data);
    }
    if (menu) {
      const searchTerms = menu.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.name && search.name.toLowerCase().includes(term)) ||
            (search?.id_parent && String(search.id_parent).includes(term)) ||
            (search?.id_sub_parent &&
              String(search.id_sub_parent).includes(term)) ||
            (search?.position && String(search.position).includes(term)),
        );
      }, data);
    }
    if (razorpaydetails) {
      const searchTerms = razorpaydetails.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.email && search.email.toLowerCase().includes(term)) ||
            (search?.id && search.id.toLowerCase().includes(term)) ||
            (search?.contact && search.contact.toLowerCase().includes(term)) ||
            (search?.order_id &&
              search.order_id.toLowerCase().includes(term)) ||
            (search?.entity && search.entity.toLowerCase().includes(term)) ||
            (search?.amount && String(search.amount).includes(term)) ||
            (search?.currency &&
              search.currency.toLowerCase().includes(term)) ||
            (search?.invoice_id &&
              search.invoice_id.toLowerCase().includes(term)) ||
            (search?.status && search.status.toLowerCase().includes(term)) ||
            (search?.method && search.method.toLowerCase().includes(term)) ||
            (search?.amount_refunded &&
              String(search.amount_refunded).includes(term)) ||
            (search?.refund_status &&
              search.refund_status.toLowerCase().includes(term)) ||
            (search?.captured && String(search.captured).includes(term)) ||
            (search?.description &&
              search.description.toLowerCase().includes(term)) ||
            (search?.bank && search.bank.toLowerCase().includes(term)) ||
            (search?.tax && String(search.tax).includes(term)) ||
            (search?.created_at && String(search.created_at).includes(term)),
        );
      }, data);
    }
    if (razorpayorderdetails) {
      const searchTerms = razorpayorderdetails.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.id && search.id.toLowerCase().includes(term)) ||
            (search?.entity && search.entity.toLowerCase().includes(term)) ||
            (search?.amount && String(search.amount).includes(term)) ||
            (search?.amount_due && String(search.amount_due).includes(term)) ||
            (search?.currency &&
              search.currency.toLowerCase().includes(term)) ||
            (search?.receipt && search.receipt.toLowerCase().includes(term)) ||
            (search?.offer_id &&
              search.offer_id.toLowerCase().includes(term)) ||
            (search?.status && search.status.toLowerCase().includes(term)) ||
            (search?.attempts && String(search.attempts).includes(term)) ||
            (search?.created_at && String(search.created_at).includes(term)) ||
            (search?.amount_paid && String(search.amount_paid).includes(term)),
        );
      }, data);
    }
    if (clientfeedback) {
      const searchTerms = clientfeedback.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.ref_no && search.ref_no.toLowerCase().includes(term)) ||
            (search?.start_date &&
              search.start_date.toLowerCase().includes(term)) ||
            (search?.end_date &&
              search.end_date.toLowerCase().includes(term)) ||
            (search?.arrival && search.arrival.toLowerCase().includes(term)) ||
            (search?.departure &&
              search.departure.toLowerCase().includes(term)) ||
            (search?.client_name &&
              search.client_name.toLowerCase().includes(term)) ||
            (search?.days_to_complete &&
              search.days_to_complete.toLowerCase().includes(term)) ||
            (search?.ontour_feedback &&
              search.ontour_feedback.toLowerCase().includes(term)) ||
            (search?.package_type &&
              search.package_type.toLowerCase().includes(term)) ||
            (search?.company_name &&
              search.company_name.toLowerCase().includes(term)) ||
            (search?.driver_name &&
              search.driver_name.toLowerCase().includes(term)) ||
            (search?.vehicle_remark &&
              search.vehicle_remark.toLowerCase().includes(term)),
        );
      }, data);
    }

    if (permit) {
      const searchTerms = permit.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => {
          const matchesFromState = search?.from_state_name
            ?.toLowerCase()
            .includes(term);
          const matchesToState = search?.to_state_name
            ?.toLowerCase()
            .includes(term);
          const matchesVehicleOrPermit = search?.vehicle_type_id?.some((id) => {
            const vehicleTypeName =
              search?.vehicle_type_names?.[id]?.toLowerCase();
            const permitValue = search?.permit?.[id]?.toString().toLowerCase();
            return (
              (vehicleTypeName && vehicleTypeName.includes(term)) ||
              (permitValue && permitValue.includes(term))
            );
          });

          return matchesFromState || matchesToState || matchesVehicleOrPermit;
        });
      }, data || []);
    }

    if (partialpayment) {
      const searchTerms = partialpayment.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.less_than &&
              search.less_than.toLowerCase().includes(term)) ||
            (search?.more_than &&
              search.more_than.toLowerCase().includes(term)),
        );
      }, data);
    }
    if (subusers) {
      const searchTerms = subusers.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.agent_email &&
              search.agent_email.toLowerCase().includes(term)) ||
            (search?.agent_reference &&
              search.agent_reference.toLowerCase().includes(term)) ||
            (search?.reference_user &&
              search.reference_user.toLowerCase().includes(term)) ||
            (search?.username &&
              search.username.toLowerCase().includes(term)) ||
            (search?.email && search.email.toLowerCase().includes(term)) ||
            (search?.mobile && search.mobile.toLowerCase().includes(term)) ||
            (search?.role_name &&
              search.role_name.toLowerCase().includes(term)),
        );
      }, data);
    }
    if (billpaymentreport) {
      const searchTerms = billpaymentreport.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.client_name &&
              search.client_name.toLowerCase().includes(term)) ||
            (search?.ref_no && search.ref_no.toLowerCase().includes(term)) ||
            (search?.start_date &&
              search.start_date.toLowerCase().includes(term)) ||
            (search?.end_date &&
              search.end_date.toLowerCase().includes(term)) ||
            (search?.arrival && search.arrival.toLowerCase().includes(term)) ||
            (search?.purchase_rate &&
              search.purchase_rate.toLowerCase().includes(term)) ||
            (search?.tds && search.tds.toLowerCase().includes(term)) ||
            (search?.vendor_name &&
              search.vendor_name.toLowerCase().includes(term)) ||
            (search?.paid_amount &&
              search.paid_amount.toLowerCase().includes(term)) ||
            (search?.total_trip_advance_paid &&
              search.total_trip_advance_paid.toLowerCase().includes(term)) ||
            (search?.trip_date &&
              search.trip_date.toLowerCase().includes(term)) ||
            (search?.vehicle_driver_change_remark &&
              search.vehicle_driver_change_remark
                .toLowerCase()
                .includes(term)) ||
            (search?.remaining_individual_amt &&
              search.remaining_individual_amt.toLowerCase().includes(term)),
        );
      }, data);
    }
    if (tripadvance) {
      const searchTerms = tripadvance.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.ref_no && search.ref_no.toLowerCase().includes(term)) ||
            (search?.client_name &&
              search.client_name.toLowerCase().includes(term)) ||
            (search?.start_date &&
              search.start_date.toLowerCase().includes(term)) ||
            (search?.arrival && search.arrival.toLowerCase().includes(term)) ||
            (search?.departure &&
              search.departure.toLowerCase().includes(term)) ||
            (search?.vehicle_type &&
              search.vehicle_type.toLowerCase().includes(term)) ||
            (search?.vendor_name &&
              search.vendor_name.toLowerCase().includes(term)) ||
            (search?.trip_advance_request &&
              String(search.trip_advance_request).includes(term)) ||
            (search?.trip_advance_paid &&
              String(search.trip_advance_paid).toLowerCase().includes(term)) ||
            (search?.approval_status &&
              search.approval_status.toLowerCase().includes(term)) ||
            (search?.paid_status &&
              search.paid_status.toLowerCase().includes(term)) ||
            (search?.paid_remark &&
              search.paid_remark.toLowerCase().includes(term)) ||
            (search?.vehicle_driver_change_remark &&
              search.vehicle_driver_change_remark.toLowerCase().includes(term)),
        );
      }, data);
    }
    if (tripadvancepayment) {
      const searchTerms = tripadvancepayment.toLowerCase().split(" ");
      // The "Ready to Pay" tab groups rows by vendor (groupBillPaymentRows in
      // tripAdvanceModel.js), which turns ref_no/client_name/start_date/
      // arrival/departure into arrays (one entry per booking under that
      // vendor) instead of plain strings — every other tab keeps them
      // scalar. Normalize both shapes to a searchable string here so the
      // same field can be either without throwing.
      const toText = (value) =>
        Array.isArray(value) ? value.join(" ") : value;

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.ref_no &&
              toText(search.ref_no).toLowerCase().includes(term)) ||
            (search?.client_name &&
              toText(search.client_name).toLowerCase().includes(term)) ||
            (search?.start_date &&
              toText(search.start_date).toLowerCase().includes(term)) ||
            (search?.arrival &&
              toText(search.arrival).toLowerCase().includes(term)) ||
            (search?.departure &&
              toText(search.departure).toLowerCase().includes(term)) ||
            (search?.vehicle_type &&
              toText(search.vehicle_type).toLowerCase().includes(term)) ||
            (search?.vendor_name &&
              toText(search.vendor_name).toLowerCase().includes(term)) ||
            (search?.trip_advance_request &&
              String(search.trip_advance_request).includes(term)) ||
            (search?.trip_advance_paid &&
              String(search.trip_advance_paid).toLowerCase().includes(term)) ||
            (search?.approval_status &&
              toText(search.approval_status).toLowerCase().includes(term)) ||
            (search?.paid_status &&
              toText(search.paid_status).toLowerCase().includes(term)) ||
            (search?.paid_remark &&
              toText(search.paid_remark).toLowerCase().includes(term)) ||
            (search?.no_of_days &&
              String(search.no_of_days).toLowerCase().includes(term)),
        );
      }, data);
    }
    if (paymentdetails) {
      const searchTerms = paymentdetails.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.agent_id &&
              search.agent_id.toLowerCase().includes(term)) ||
            (search?.ref_no && search.ref_no.toLowerCase().includes(term)) ||
            (search?.order_id &&
              search.order_id.toLowerCase().includes(term)) ||
            (search?.payment_id &&
              search.payment_id.toLowerCase().includes(term)) ||
            (search?.amount && String(search.amount).includes(term)) ||
            (search?.customer_name &&
              search.customer_name.toLowerCase().includes(term)) ||
            (search?.payment_status &&
              search.payment_status.toLowerCase().includes(term)) ||
            (search?.payment_type &&
              search.payment_type.toLowerCase().includes(term)) ||
            (search?.previous_balance &&
              String(search.previous_balance).includes(term)) ||
            (search?.current_balance &&
              String(search.current_balance).includes(term)) ||
            (search?.is_recharge && String(search.is_recharge).includes(term)),
        );
      }, data);
    }
    if (billdetailspayment) {
      const searchTerms = billdetailspayment.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.ref_no && search.ref_no.toLowerCase().includes(term)) ||
            (search?.client_name &&
              search.client_name.toLowerCase().includes(term)) ||
            (search?.end_date &&
              search.end_date.toLowerCase().includes(term)) ||
            (search?.start_date &&
              search.start_date.toLowerCase().includes(term)) ||
            (search?.arrival && search.arrival.toLowerCase().includes(term)) ||
            (search?.departure &&
              search.departure.toLowerCase().includes(term)) ||
            (search?.vendor_name &&
              search.vendor_name.toLowerCase().includes(term)) ||
            (search?.va_end_date &&
              String(search.va_end_date).includes(term)) ||
            (search?.va_start_date &&
              String(search.va_start_date).includes(term)) ||
            (search?.bill_amount && String(search.bill_amount).includes(term)),
        );
      }, data);
    }
    if (billapproval) {
      const searchTerms = billapproval.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.ref_no && search.ref_no.toLowerCase().includes(term)) ||
            (search?.client_name &&
              search.client_name.toLowerCase().includes(term)) ||
            (search?.start_date &&
              search.start_date.toLowerCase().includes(term)) ||
            (search?.arrival && search.arrival.toLowerCase().includes(term)) ||
            (search?.departure &&
              search.departure.toLowerCase().includes(term)) ||
            (search?.TDS && search.TDS.toLowerCase().includes(term)) ||
            (search?.vendor_name &&
              search.vendor_name.toLowerCase().includes(term)) ||
            (search?.trip_advance_request &&
              String(search.trip_advance_request).includes(term)) ||
            (search?.trip_advance_paid &&
              String(search.trip_advance_paid).toLowerCase().includes(term)) ||
            (search?.bill_amount &&
              search.bill_amount.toLowerCase().includes(term)) ||
            (search?.days_difference &&
              String(search.days_difference).toLowerCase().includes(term)),
        );
      }, data);
    }
    if (jobtitle) {
      const searchTerms = jobtitle.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            search?.job_roles && search.job_roles.toLowerCase().includes(term),
        );
      }, data);
    }
    if (subscribe) {
      const searchTerms = subscribe.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.email && search.email.toLowerCase().includes(term)) ||
            (term === "active" && search?.active === 1) ||
            (term === "inactive" && search?.active === 0),
        );
      }, data);
    }
    if (itineraryperiodic) {
      const searchTerms = itineraryperiodic.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => {
          const formattedStartDate = search.start_date
            ? dayjs(search.start_date).format("DD-MM-YYYY")
            : "";
          const formattedEndDate = search.end_date
            ? dayjs(search.end_date).format("DD-MM-YYYY")
            : "";

          return (
            (search?.city_names &&
              search.city_names.toLowerCase().includes(term)) ||
            (search?.vehicle_type_id &&
              search.vehicle_type_id.some((id) => {
                const typeName = search.vehicle_type_names[id];
                const hike = search.hike?.[id]?.toString().toLowerCase();
                return (
                  (typeName && typeName.toLowerCase().includes(term)) ||
                  (hike && hike.includes(term))
                );
              })) ||
            (formattedStartDate && formattedStartDate.includes(term)) ||
            (formattedEndDate && formattedEndDate.includes(term))
          );
        });
      }, data);
    }

    if (airbasic) {
      const searchTerms = airbasic.toLowerCase().split(" ");

      data = data.filter((search) => {
        return searchTerms.every(
          (term) =>
            search?.name_of_airport?.toLowerCase().includes(term) ||
            search?.vehicle_type_id?.some((id) => {
              const typeName = search.vehicle_type_names[id];
              const minRate = search.min_rate[id]?.toString();
              const minKm = search.min_km[id]?.toString();
              const extraKm = search.extra_km[id]?.toString();
              const prime = search.prime[id]?.toString();

              return (
                (typeName && typeName.toLowerCase().includes(term)) ||
                (minRate && minRate.includes(term)) ||
                (minKm && minKm.includes(term)) ||
                (extraKm && extraKm.includes(term)) ||
                (prime && prime.includes(term))
              );
            }),
        );
      });
    }
    if (onewaybasic) {
      const searchTerms = onewaybasic.toLowerCase().split(" ");

      data = data.filter((search) => {
        return searchTerms.every(
          (term) =>
            (search?.from_city_name?.join(" ") || "")
              .toLowerCase()
              .includes(term) ||
            (search?.to_city_name?.join(" ") || "")
              .toLowerCase()
              .includes(term) ||
            search?.vehicle_type_id?.some((id) => {
              const typeName = search.vehicle_type_names?.[id];
              const minRate = search.min_rate?.[id]?.toString();
              const minKm = search.min_km?.[id]?.toString();
              const extraKm = search.extra_km?.[id]?.toString();

              return (
                (typeName && typeName.toLowerCase().includes(term)) ||
                (minRate && minRate.includes(term)) ||
                (minKm && minKm.includes(term)) ||
                (extraKm && extraKm.includes(term))
              );
            }),
        );
      });
    }
    if (onewayHikeday) {
      const searchTerms = onewayHikeday.toLowerCase().trim().split(/\s+/);

      data = data.filter((row) =>
        searchTerms.every((term) => {
          const fromCity = (row?.from_city_name || []).join(" ").toLowerCase();

          const toCity = (row?.to_city_name || []).join(" ").toLowerCase();

          if (fromCity.includes(term) || toCity.includes(term)) {
            return true;
          }

          // hike (single value)
          const hikeValue = row?.hike?.toString() || "";
          if (hikeValue.includes(term)) {
            return true;
          }

          // vehicle type name
          if (Array.isArray(row?.vehicle_type_id)) {
            return row.vehicle_type_id.some((id) => {
              const typeName =
                row.vehicle_type_names?.[id]?.toLowerCase() || "";
              return typeName.includes(term);
            });
          }

          return false;
        }),
      );
    }

    if (airPeriodicday) {
      const searchTerms = airPeriodicday.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => {
          const formattedStartDate = search.start_date
            ? dayjs(search.start_date).format("DD-MM-YYYY")
            : "";
          const formattedEndDate = search.end_date
            ? dayjs(search.end_date).format("DD-MM-YYYY")
            : "";

          return (
            (search?.city_names &&
              search.city_names.toLowerCase().includes(term)) ||
            (search?.vehicle_type_id &&
              search.vehicle_type_id.some((id) => {
                const typeName = search.vehicle_type_names[id];
                const hike = search.hike?.[id]?.toString().toLowerCase();
                return (
                  (typeName && typeName.toLowerCase().includes(term)) ||
                  (hike && hike.includes(term))
                );
              })) ||
            (formattedStartDate && formattedStartDate.includes(term)) ||
            (formattedEndDate && formattedEndDate.includes(term))
          );
        });
      }, data);
    }

    if (airPeriodictime) {
      const searchTerms = airPeriodictime.toLowerCase().split(" ");

      data = data.filter((search) => {
        return searchTerms.every(
          (term) =>
            search?.city_names?.toLowerCase().includes(term) ||
            search?.vehicle_type_names?.toLowerCase().includes(term) ||
            search?.start_time?.toLowerCase().includes(term) ||
            search?.end_time?.toLowerCase().includes(term) ||
            search?.hike?.toString().toLowerCase().includes(term),
        );
      });
    }

    const cleanTime = (value = "") => value.replace(/[{}"]/g, "").toLowerCase();
    if (OnewayPeriodicTime) {
      const searchTerms = OnewayPeriodicTime.trim().toLowerCase().split(/\s+/);

      data = data.filter((row) =>
        searchTerms.every((term) => {
          const fromCity = row.from_city?.toLowerCase() || "";
          const toCity = row.to_city?.toLowerCase() || "";
          const startTime = cleanTime(row.start_time);
          const endTime = cleanTime(row.end_time);

          const vehicleMatch = Array.isArray(row.vehicles)
            ? row.vehicles.some(
                (v) =>
                  v.vehicle_type?.toLowerCase().includes(term) ||
                  v.hike?.toString().includes(term),
              )
            : false;

          return (
            fromCity.includes(term) ||
            toCity.includes(term) ||
            startTime.includes(term) ||
            endTime.includes(term) ||
            vehicleMatch
          );
        }),
      );
    }

    if (daybasic) {
      const searchTerms = daybasic.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.city && search.city.toLowerCase().includes(term)) ||
            search?.vehicle_type_id?.some((id) => {
              const typeName = search?.vehicle_type_names?.[id];
              const minRate = search?.min_rate?.[id]?.toString().toLowerCase();
              const minKm = search?.min_km?.[id]?.toString().toLowerCase();
              const extraKm = search?.extra_km?.[id]?.toString().toLowerCase();
              const driverBeta = search?.driver_beta?.[id]
                ?.toString()
                .toLowerCase();
              const nightAllowance = search?.night_allowance?.[id]
                ?.toString()
                .toLowerCase();
              const duration = search?.duration?.[id]?.toString().toLowerCase();
              const prime = search?.prime?.[id]?.toString().toLowerCase();

              return (
                (typeName && typeName.toLowerCase().includes(term)) ||
                (minRate && minRate.includes(term)) ||
                (minKm && minKm.includes(term)) ||
                (extraKm && extraKm.includes(term)) ||
                (driverBeta && driverBeta.includes(term)) ||
                (nightAllowance && nightAllowance.includes(term)) ||
                (duration && duration.includes(term)) ||
                (prime && prime.includes(term))
              );
            }),
        );
      }, data);
    }

    if (agent) {
      const searchTerms = agent.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.company_name &&
              search.company_name.toLowerCase().includes(term)) ||
            (search?.reference_no &&
              search.reference_no.toLowerCase().includes(term)) ||
            (search?.city_name &&
              search.city_name.toLowerCase().includes(term)) ||
            (search?.state_name &&
              search.state_name.toLowerCase().includes(term)) ||
            (search?.mobile_no &&
              search.mobile_no.toLowerCase().includes(term)) ||
            (search?.email_id &&
              search.email_id.toLowerCase().includes(term)) ||
            (search?.company_name &&
              search.company_name.toLowerCase().includes(term)),
        );
      }, data);
    }

    if (dayperiodic) {
      const searchTerms = dayperiodic.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => {
          const formattedStartDate = search.start_date
            ? dayjs(search.start_date).format("DD-MM-YYYY")
            : "";
          const formattedEndDate = search.end_date
            ? dayjs(search.end_date).format("DD-MM-YYYY")
            : "";

          return (
            (search?.city_names &&
              search.city_names.toLowerCase().includes(term)) ||
            (search?.vehicle_type_id &&
              search.vehicle_type_id.some((id) => {
                const typeName = search.vehicle_type_names[id];
                const hike = search.hike?.[id]?.toString().toLowerCase();
                return (
                  (typeName && typeName.toLowerCase().includes(term)) ||
                  (hike && hike.includes(term))
                );
              })) ||
            (formattedStartDate && formattedStartDate.includes(term)) ||
            (formattedEndDate && formattedEndDate.includes(term))
          );
        });
      }, data);
    }

    if (hourPeriodicday) {
      const searchTerms = hourPeriodicday.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => {
          const formattedStartDate = search.start_date
            ? dayjs(search.start_date).format("DD-MM-YYYY")
            : "";
          const formattedEndDate = search.end_date
            ? dayjs(search.end_date).format("DD-MM-YYYY")
            : "";

          return (
            (search?.city_names &&
              search.city_names.toLowerCase().includes(term)) ||
            (search?.vehicle_type_id &&
              search.vehicle_type_id.some((id) => {
                const typeName = search.vehicle_type_names[id];
                const hike = search.hike?.[id]?.toString().toLowerCase();
                return (
                  (typeName && typeName.toLowerCase().includes(term)) ||
                  (hike && hike.includes(term))
                );
              })) ||
            (formattedStartDate && formattedStartDate.includes(term)) ||
            (formattedEndDate && formattedEndDate.includes(term))
          );
        });
      }, data);
    }

    if (hourPeriodictime) {
      const searchTerms = hourPeriodictime.toLowerCase().split(" ");

      data = data.filter((search) => {
        return searchTerms.every(
          (term) =>
            search?.city_names?.toLowerCase().includes(term) ||
            search?.vehicle_type_names?.toLowerCase().includes(term) ||
            search?.hike?.toString().toLowerCase().includes(term) ||
            search?.start_time?.toLowerCase().includes(term) ||
            search?.end_time?.toLowerCase().includes(term),
        );
      });
    }

    if (vendor) {
      const searchTerms = vendor.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.authorized_person &&
              search.authorized_person.toLowerCase().includes(term)) ||
            (search?.reference_no &&
              search.reference_no?.toLowerCase().includes(term)) ||
            (search?.company_name &&
              search.company_name?.toLowerCase().includes(term)) ||
            (search?.franchise_partner_name &&
              search.franchise_partner_name?.toLowerCase().includes(term)) ||
            (search?.destination &&
              search.destination?.toLowerCase().includes(term)) ||
            (search?.email && search.email?.toLowerCase().includes(term)),
        );
      }, data);
    }
    if (vehicleModel) {
      const searchTerms = vehicleModel.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            (search?.name && search.name.toLowerCase().includes(term)) ||
            (search?.vehcilecategory &&
              search.vehcilecategory?.toLowerCase().includes(term)),
        );
      }, data);
    }

    if (vehicleColor) {
      data = data.filter((search) =>
        search
          ? search["Vehicle Color"]
              .toLowerCase()
              .includes(vehicleColor.toLowerCase())
          : false,
      );
    }
    if (vehicleBrand) {
      data = data.filter((search) =>
        search
          ? search["Vehicle Brand"]
              .toLowerCase()
              .includes(vehicleBrand.toLowerCase())
          : false,
      );
    }
    if (vehicleSeats) {
      data = data.filter((search) =>
        search
          ? search["Vehicle Seats"]
              .toLowerCase()
              .includes(vehicleSeats.toLowerCase())
          : false,
      );
    }
    //country filtering
    if (country) {
      data = data.filter(
        (cou) =>
          cou?.name?.toLowerCase().includes(country.toLowerCase()) ||
          cou?.iso_code?.toLowerCase().includes(country.toLowerCase()),
      );
    }
    if (sales) {
      const searchTerms = sales.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (entry) =>
            (entry?.client_name &&
              entry.client_name.toLowerCase().includes(term)) ||
            (entry?.client_ref &&
              entry.client_ref.toLowerCase().includes(term)) ||
            (entry?.agentname &&
              entry.agentname.toLowerCase().includes(term)) ||
            (entry?.agentref && entry.agentref.toLowerCase().includes(term)) ||
            (entry?.arrival && entry.arrival.toLowerCase().includes(term)) ||
            (entry?.departure &&
              entry.departure.toLowerCase().includes(term)) ||
            (entry?.arrival_via &&
              entry.arrival_via.toLowerCase().includes(term)) ||
            (entry?.departure_via &&
              entry.departure_via.toLowerCase().includes(term)) ||
            (entry?.seller_name &&
              entry.seller_name.toLowerCase().includes(term)) ||
            (entry?.seller_mobile &&
              entry.seller_mobile.toLowerCase().includes(term)) ||
            (entry?.payment_type &&
              entry.payment_type.toLowerCase().includes(term)) ||
            (entry?.payment_status &&
              entry.payment_status.toLowerCase().includes(term)) ||
            (entry?.start_date &&
              entry.start_date.toLowerCase().includes(term)) ||
            (entry?.end_date && entry.end_date.toLowerCase().includes(term)) ||
            (entry?.remark && entry.remark.toLowerCase().includes(term)) ||
            (entry?.sales_created_at &&
              entry.sales_created_at.toLowerCase().includes(term)) ||
            (entry?.sales_updated_at &&
              entry.sales_updated_at.toLowerCase().includes(term)) ||
            (entry?.online_or_offline &&
              entry.online_or_offline.toLowerCase().includes(term)) ||
            (entry?.selling_price &&
              entry.selling_price.toString().includes(term)) ||
            (entry?.received_amt &&
              entry.received_amt.toString().includes(term)) ||
            (entry?.balance_amt &&
              entry.balance_amt.toString().includes(term)) ||
            (entry?.shortage && entry.shortage.toString().includes(term)),
        );
      }, data);
    }
    if (revenueReport) {
      const searchTerms = revenueReport.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((entry) => {
          // Compute profit/loss label
          const profitValue =
            Number(entry.sales_amount) -
            Number(entry.total_vehicle_bill_amount);
          const profitOrLossLabel = profitValue >= 0 ? "profit" : "loss";

          // Combine all searchable fields into one string without newlines
          const searchableText = [
            entry?.client_name,
            entry?.ref_no,
            entry?.agent_company_name,
            entry?.agent_ref_no,
            entry?.arrival_city,
            entry?.departure_city,
            entry?.start_date,
            entry?.end_date,
            entry?.selling_price,
            entry?.sales_amount,
            entry?.total_vehicle_bill_amount,
            entry?.profit,
            profitOrLossLabel,
          ]
            .filter(Boolean)
            .join(" ")
            .toLowerCase();

          return searchableText.includes(term);
        });
      }, data);
    }

    if (parking) {
      //   console.log(parking);
      const searchTerms = parking.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((item) => {
          // Check city_name and sight_seeing
          const matchesCity = item.city_name?.toLowerCase().includes(term);
          const matchesSight = item.sight_seeing?.toLowerCase().includes(term);

          // Check costs values
          const matchesCosts = item.costs
            ? Object.values(item.costs).some((val) =>
                val.toString().toLowerCase().includes(term),
              )
            : false;

          return matchesCity || matchesSight || matchesCosts;
        });
      }, data);
    }

    if (whatsapp) {
      //   console.log(whatsapp);

      // Convert the search term into lowercase words
      const searchTerms = whatsapp.toLowerCase().split(" ");

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((item) => {
          // Try to match by common fields safely
          const matchesName = item.name?.toLowerCase().includes(term);
          const matchesTemplateName = item.template_name
            ?.toLowerCase()
            .includes(term);
          const matchesCategory = item.category?.toLowerCase().includes(term);
          const matchesLanguage = item.language?.toLowerCase().includes(term);
          const matchesContent = item.content?.toLowerCase().includes(term);
          const matchesStatus = item.status?.toLowerCase().includes(term);

          // If any of these fields match → include it
          return (
            matchesName ||
            matchesTemplateName ||
            matchesCategory ||
            matchesLanguage ||
            matchesContent ||
            matchesStatus
          );
        });
      }, data);
    }
    if (cityVendorRequest) {
      // Safely handle empty or undefined search input
      const searchValue = cityVendorRequest.trim().toLowerCase();
      if (searchValue) {
        const searchTerms = searchValue.split(/\s+/); // split on any space(s)

        data = searchTerms.reduce((filteredData, term) => {
          return filteredData.filter(
            (item) =>
              (item?.company_name &&
                item.company_name.toLowerCase().includes(term)) ||
              (item?.full_name &&
                item.full_name.toLowerCase().includes(term)) ||
              (item?.city_name &&
                item.city_name.toLowerCase().includes(term)) ||
              (item?.state_name &&
                item.state_name.toLowerCase().includes(term)),
          );
        }, data);
      }
    }

    if (seoVirtual) {
      const searchTerms = seoVirtual.toLowerCase().split(" ");

      data = data.filter((search) => {
        return searchTerms.every(
          (term) =>
            search?.url?.toLowerCase().includes(term) ||
            search?.keywords?.toLowerCase().includes(term) ||
            search?.title?.toLowerCase().includes(term),
        );
      });
    }
    if (News) {
      const searchTerms = News.toLowerCase().split(" ");

      data = data.filter((item) => {
        const title = Array.isArray(item?.title)
          ? item.title.join(" ")
          : item?.title || "";

        const description = Array.isArray(item?.description)
          ? item.description.join(" ")
          : item?.description || "";

        const url = item?.url || "";

        return searchTerms.every(
          (term) =>
            title.toLowerCase().includes(term) ||
            description.toLowerCase().includes(term) ||
            url.toLowerCase().includes(term),
        );
      });
    }

    if (minDuration?.trim()) {
      const searchTerms = minDuration
        .trim() // remove start & end spaces
        .toLowerCase()
        .split(/\s+/); // remove multiple spaces

      data = data.filter((item) => {
        const name = item?.name
          ? item.name.toString().toLowerCase().trim()
          : "";

        const minBookingMinutes =
          item?.min_booking_minutes !== undefined
            ? item.min_booking_minutes.toString().trim()
            : "";

        return searchTerms.every(
          (term) => name.includes(term) || minBookingMinutes.includes(term),
        );
      });
    }

    if (franchiseAllotSearch) {
      const searchTerms = franchiseAllotSearch
        .toLowerCase()
        .trim()
        .split(/\s+/);

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (search) =>
            search?.ref_no?.toLowerCase().includes(term) ||
            search?.client_name?.toLowerCase().includes(term) ||
            search?.franchise_name?.toLowerCase().includes(term) ||
            search?.departure_name?.toLowerCase().includes(term) ||
            search?.arrival_name?.toLowerCase().includes(term) ||
            search?.vehiclename?.toLowerCase().includes(term) ||
            search?.package_type?.toLowerCase().includes(term) ||
            search?.start_date?.toLowerCase().includes(term) ||
            search?.end_date?.toLowerCase().includes(term) ||
            search?.franchise_status?.toLowerCase().includes(term),
        );
      }, data);
    }

    if (franchiseSearch) {
      const searchTerms = franchiseSearch.toLowerCase().trim().split(/\s+/);

      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter(
          (item) =>
            item?.company_name?.toLowerCase().includes(term) ||
            item?.owner_name?.toLowerCase().includes(term) ||
            item?.reference_no?.toLowerCase().includes(term) ||
            item?.email_id?.toLowerCase().includes(term) ||
            item?.phone_no?.toLowerCase().includes(term) ||
            item?.city?.name?.toLowerCase().includes(term) ||
            item?.state?.name?.toLowerCase().includes(term) ||
            item?.status?.toLowerCase().includes(term),
        );
      }, data);
    }

    return data;
  }, [
    time,
    data,
    location.pathname,
    filter,
    sortedField,
    searchUser,
    purchasebill,
    vendor,
    vendorRequest,
    cityVendorRequest,
    onewayHikeday,
    vehicleCategory,
    vehicletype,
    hourbasic,
    seoManageCity,
    seoPage,
    itinerarybasic,
    itineraryperiodic,
    topselling,
    booking,
    driver,
    driverqueue,
    vehicle,
    advertisement,
    contact,
    career,
    languagedriver,
    menu,
    billdetailspayment,
    razorpaydetails,
    razorpayorderdetails,
    clientfeedback,
    permit,
    partialpayment,
    subusers,
    billpaymentreport,
    tripadvance,
    paymentdetails,
    tripadvancepayment,
    jobtitle,
    sold,
    soldAir,
    subscribe,
    airbasic,
    onewaybasic,

    airPeriodicday,
    airPeriodictime,
    OnewayPeriodicTime,
    daybasic,
    agent,
    dayperiodic,
    hourPeriodicday,
    hourPeriodictime,
    vehicleModel,
    vehicleAllot,
    vendorAllot,
    vehicleBrand,
    vehicleColor,
    vehicleSeats,
    status,
    country,
    billapproval,

    sales,
    revenueReport,
    parking,
    whatsapp,
    seoVirtual,
    News,
    minDuration,
    franchiseAllotSearch,
    franchiseSearch,
  ]);

  //pagination functionality start
  const resultsPerPage = itemsPerPage;
  const totalResults = serviceData?.length;
  const handleChangePage = (p) => {
    setCurrentPage(p);
  };
  useEffect(() => {
    if (!serviceData || serviceData.length === 0) return;

    const paginatedData = serviceData.slice(
      (currentPage - 1) * resultsPerPage,
      currentPage * resultsPerPage,
    );

    const prev = prevDataRef.current;

    const isSame =
      prev.length === paginatedData.length &&
      prev.every((item, index) => item === paginatedData[index]);

    if (isSame) return;

    prevDataRef.current = paginatedData;
    setDataTable(paginatedData);
  }, [serviceData, currentPage, resultsPerPage]);

  //pagination functionality end
  //table form submit function for search start

  const handleSubmitUser = (e) => {
    e.preventDefault();
    setSearchUser(userRef.current.value);
  };
  const handleSubmitVendor = (e) => {
    e.preventDefault();
    setVendor(vendorRef.current.value);
  };
  const handleSubmitVendorRequest = (e) => {
    e.preventDefault();
    setVendorRequest(vendorRequestRef.current.value);
  };
  const handleSubmitchannelpartner = (e) => {
    e.preventDefault();
    setVendorRequest(channelPartnerListref.current.value);
  };

  const handleSubmitCityVendorRequest = (e) => {
    e.preventDefault();

    setCityVendorRequest(cityVendorRequestRef.current.value);
  };
  const handleSubmitVehicleCategory = (e) => {
    e.preventDefault();
    setVehicleCategory(vehicleCategoryRef.current.value);
  };
  const handleSubmitBillApproval = (e) => {
    e.preventDefault();
    setBillApproval(billapprovalRef.current.value);
  };
  const handleSubmitVehicleType = (e) => {
    e.preventDefault();
    setVehicletype(vehicleTypeRef.current.value);
  };
  const handleSubmitHourRentalBasicRate = (e) => {
    e.preventDefault();
    setHourBasic(hourRentalBasicRateRef.current.value);
  };
  const handleSubmitFixedItinerary = (e) => {
    e.preventDefault();
    setItineraryBasic(fixedItineraryRef.current.value);
  };
  const handleSubmitFixedItineraryPeriodicHike = (e) => {
    e.preventDefault();
    setItineraryPeriodic(fixedItineraryPeriodicHikeRef.current.value);
  };
  const handleSubmitSeoManageCity = (e) => {
    e.preventDefault();
    setSeoManageCity(SeoManageCityRef.current.value);
  };
  const handleSubmitSeoPage = (e) => {
    e.preventDefault();
    setSeoPage(seoPageRef.current.value);
  };
  const handleSubmitTopSelling = (e) => {
    e.preventDefault();
    setTopselling(topSellingRef.current.value);
  };
  const handleSubmitBookings = (e) => {
    e.preventDefault();
    setBooking(bookingRef.current.value);
  };
  const handleSubmitVehicle = (e) => {
    e.preventDefault();
    setVehicle(vehicleRef.current.value);
  };
  const handleSubmitAdvertisement = (e) => {
    e.preventDefault();
    setAdvertisement(advertisementRef.current.value);
  };
  const handleSubmitContact = (e) => {
    e.preventDefault();
    setContact(contactRef.current.value);
  };
  const handleSubmitCareer = (e) => {
    e.preventDefault();
    setCareer(careerRef.current.value);
  };
  const handleSubmitLanguageDriver = (e) => {
    e.preventDefault();
    setLanguageDriver(languagedriverRef.current.value);
  };
  const handleSubmitMenu = (e) => {
    e.preventDefault();
    setMenu(menuRef.current.value);
  };
  const handleSubmitRazorpayDetails = (e) => {
    e.preventDefault();
    setRazorpayDetails(razorpaydetailsRef.current.value);
  };
  const handleSubmitRazorpayOrderDetails = (e) => {
    e.preventDefault();
    setRazorpayOrderDetails(razorpayorderdetailsRef.current.value);
  };
  const handleSubmitClientFeedback = (e) => {
    e.preventDefault();
    setClientFeedback(clientfeedbackRef.current.value);
  };
  const handleSubmitPermit = (e) => {
    e.preventDefault();
    setPermit(permitRef.current.value);
  };
  const handleSubmitPartialPayment = (e) => {
    e.preventDefault();
    setPartialPayment(partialpaymentRef.current.value);
  };
  const handleSubmitSubusers = (e) => {
    e.preventDefault();
    setSubusers(subusersRef.current.value);
  };
  const handleSubmitBillPaymentReport = (e) => {
    e.preventDefault();
    setBillPaymentReport(billpaymentreportRef.current.value);
  };
  const handleSubmitTripadvance = (e) => {
    e.preventDefault();
    setTripadvance(tripadvanceRef.current.value);
  };
  const handleSubmitTripadvancePayment = (e) => {
    e.preventDefault();
    setTripadvancePayment(tripadvancepaymentRef.current.value);
  };
  const handleSubmitSold = (e) => {
    e.preventDefault();
    setSold(soldRef.current.value);
  };
  const handleSubmitSoldAirport = (e) => {
    e.preventDefault();
    setSoldAir(soldAirportRef.current.value);
  };
  const handleSubmitPaymentDetails = (e) => {
    e.preventDefault();
    setPaymentDetails(paymentdetailsRef.current.value);
  };
  const handleSubmitJobtitle = (e) => {
    e.preventDefault();
    setJobtitle(jobtitleRef.current.value);
  };
  const handleSubmitSubscribe = (e) => {
    e.preventDefault();
    setSubscribe(subscribeRef.current.value);
  };

  const handleSubmitDriver = (e) => {
    e.preventDefault();
    setDriver(driverRef.current.value);
  };

  const handleSubmitBill = (e) => {
    e.preventDefault();
    setPurchaseBill(billRef.current.value);
  };

  const handleSubmitDriverqueue = (e) => {
    e.preventDefault();
    setDriverqueue(driverqueueRef.current.value);
  };
  const handleSubmitDayRentalBasicRate = (e) => {
    e.preventDefault();
    setDayBasic(dayRentalBasicRateRef.current.value);
  };
  const handleSubmitAgents = (e) => {
    e.preventDefault();
    setAgent(agentsRef.current.value);
  };
  const handleSubmitVehicleAllot = (e) => {
    e.preventDefault();
    setVehicleAllot(vehicleAllotRef.current.value);
  };
  const handleSubmitVendorAlot = (e) => {
    e.preventDefault();
    setVendorAlot(vendoralotRef.current.value);
  };
  const handleSubmitFranchiseAlot = (e) => {
    e.preventDefault();
    setFranchiseAlotSearch(franchisealotRef.current.value);
  };
  const handleSubmitFranchise = (e) => {
    e.preventDefault();
    setFranchiseSearch(franchiseRef.current.value);
  };
  const handleSubmitAirportPickupBasicRate = (e) => {
    e.preventDefault();
    setAirBasic(airportPickupBasicRateRef.current.value);
  };
  const handleSubmitOnewayPickupBasicRate = (e) => {
    e.preventDefault();
    setonewaybasic(onewayPickupBasicRateRef.current.value);
  };

  const handleSubmitNews = (e) => {
    e.preventDefault();
    setNews(newsRef.current.value);
  };

  const handleSubmitminDuration = (e) => {
    e.preventDefault();
    setminDuration(minDurationRef.current.value);
  };

  const handleSubmitOnewayPickupPeriodicHikeDay = (e) => {
    e.preventDefault();
    setonewayHikeday(onewayPickupHideDayRef.current.value);
  };

  const handleSubmitAirportPickupPeriodicHikeDay = (e) => {
    e.preventDefault();
    setAirPeriodicDay(airportPickupPeriodicHikeDayRef.current.value);
  };
  const handleSubmitAirportPickupPeriodicHikeTime = (e) => {
    e.preventDefault();
    setAirPeriodicTime(airportPickupPeriodicHikeTimeRef.current.value);
  };

  const handleChangeOnewayPickupPeriodicHikeTime = (e) => {
    e.preventDefault();
    setOnewayPeriodicTime(onewayPickupPeriodicHikeTimeRef.current.value);
  };

  const handleSubmitDayRentalPeriodicHikeDay = (e) => {
    e.preventDefault();
    setDayPeriodic(dayRentalPeriodicHikeDayRef.current.value);
  };
  const handleSubmitHourRentalPeriodicHikeDay = (e) => {
    e.preventDefault();
    setHourPeriodicDay(hourRentalPeriodicHikeDayRef.current.value);
  };
  const handleSubmitHourRentalPeriodicHikeTime = (e) => {
    e.preventDefault();
    setHourPeriodicTime(hourRentalPeriodicHikeTimeRef.current.value);
  };
  const handleSubmitVehicleModel = (e) => {
    e.preventDefault();
    setVehicleModel(vehicleModelRef.current.value);
  };
  const handleSubmitVehicleBrand = (e) => {
    e.preventDefault();
    setVehicleBrand(vehicleBrandRef.current.value);
  };
  const handleSubmitVehicleColor = (e) => {
    e.preventDefault();
    setVehicleColor(vehicleColorRef.current.value);
  };

  const handleSubmitVehicleSeats = (e) => {
    e.preventDefault();
    setVehicleSeats(vehicleSeatsRef.current.value);
  };
  const handleSubmitCountry = (e) => {
    e.preventDefault();
    setCountry(countryRef.current.value);
  };
  const handleSubmitBillDetailsPayment = (e) => {
    e.preventDefault();
    setBilldetailspayment(billdetailspaymentRef.current.value);
  };
  const handleSubmitSales = (e) => {
    e.preventDefault();
    // console.log(SalesRef.current.value)
    setSales(SalesRef.current.value);
  };
  const handleSubmitRevenueReport = (e) => {
    e.preventDefault();
    // console.log(SalesRef.current.value)
    setRevenueReport(RevenueReportRef.current.value);
  };

  const handleSubmitParking = (e) => {
    e.preventDefault();
    setParking(ParkingRef.current.value);
  };

  const handleSubmitWhatsapp = (e) => {
    e.preventDefault();
    setWhatsapp(WhatsappRef.current.value);
  };

  // table form submit function for search end
  // handle submit multiple product data with csv format
  const handleOnDrop = (data) => {
    for (let i = 0; i < data.length; i++) {
      newProducts.push(data[i].data);
    }
  };

  const handleSubmitSeoVirtual = (e) => {
    e.preventDefault();
    setSeoVirtual(seoVirtualRef.current.value);
  };

  return {
    minDurationRef,
    billdetailspaymentRef,
    vehicleModelRef,
    vehicleBrandRef,
    vehicleColorRef,
    vehicleSeatsRef,
    userRef,
    vehicleCategoryRef,
    billapprovalRef,
    vehicleTypeRef,
    hourRentalBasicRateRef,
    fixedItineraryRef,
    SeoManageCityRef,
    seoPageRef,
    fixedItineraryPeriodicHikeRef,
    topSellingRef,
    bookingRef,
    driverRef,
    billRef,
    driverqueueRef,
    vehicleRef,
    advertisementRef,
    contactRef,
    careerRef,
    languagedriverRef,
    menuRef,
    razorpaydetailsRef,
    razorpayorderdetailsRef,
    clientfeedbackRef,
    permitRef,
    partialpaymentRef,
    subusersRef,
    billpaymentreportRef,
    tripadvanceRef,
    tripadvancepaymentRef,
    paymentdetailsRef,
    jobtitleRef,
    subscribeRef,
    dayRentalBasicRateRef,
    agentsRef,
    vehicleAllotRef,
    vendoralotRef,
    airportPickupBasicRateRef,
    franchiseRef,
    franchisealotRef,
    franchiseAllotSearch,
    franchiseSearch,
    airportPickupPeriodicHikeDayRef,
    airportPickupPeriodicHikeTimeRef,
    onewayPickupPeriodicHikeTimeRef,
    dayRentalPeriodicHikeDayRef,
    hourRentalPeriodicHikeDayRef,
    hourRentalPeriodicHikeTimeRef,
    vendorRef,
    vendorRequestRef,
    cityVendorRequestRef,
    onewayPickupBasicRateRef,
    onewayPickupHideDayRef,
    channelPartnerListref,
    newsRef,

    searchRef,
    couponRef,
    orderRef,
    categoryRef,
    attributeRef,
    pending,
    processing,
    delivered,
    todayOrder,
    monthlyOrder,
    totalOrder,
    setFilter,
    setSortedField,
    setStatus,
    time,
    setTime,
    handleChangePage,
    totalResults,
    resultsPerPage,
    dataTable,
    serviceData,
    handleSubmitUser,
    handleSubmitVehicleCategory,
    handleSubmitVehicleType,
    handleSubmitHourRentalBasicRate,
    handleSubmitFixedItinerary,
    handleSubmitFixedItineraryPeriodicHike,
    handleSubmitSeoManageCity,
    handleSubmitSeoPage,
    handleSubmitTopSelling,
    handleSubmitBookings,
    handleSubmitDriver,
    handleSubmitBill,
    handleSubmitVendorAlot,
    handleSubmitFranchiseAlot,
    handleSubmitFranchise,
    handleSubmitDriverqueue,
    handleSubmitVehicle,
    handleSubmitAdvertisement,
    handleSubmitContact,
    handleSubmitCareer,
    handleSubmitLanguageDriver,
    handleSubmitMenu,
    handleSubmitRazorpayDetails,
    handleSubmitRazorpayOrderDetails,
    handleSubmitClientFeedback,
    handleSubmitPermit,
    handleSubmitPartialPayment,
    handleSubmitSubusers,
    handleSubmitBillPaymentReport,
    handleSubmitTripadvance,
    handleSubmitTripadvancePayment,
    handleSubmitPaymentDetails,
    handleSubmitJobtitle,
    handleSubmitSubscribe,
    handleSubmitDayRentalBasicRate,
    handleSubmitAgents,
    handleSubmitVehicleAllot,
    handleSubmitAirportPickupBasicRate,
    handleSubmitOnewayPickupBasicRate,
    handleSubmitOnewayPickupPeriodicHikeDay,
    handleSubmitAirportPickupPeriodicHikeDay,
    handleSubmitAirportPickupPeriodicHikeTime,
    handleChangeOnewayPickupPeriodicHikeTime,
    handleSubmitDayRentalPeriodicHikeDay,
    handleSubmitHourRentalPeriodicHikeDay,
    handleSubmitHourRentalPeriodicHikeTime,
    handleSubmitVehicleModel,
    handleSubmitVehicleBrand,
    handleSubmitVehicleColor,
    handleSubmitVehicleSeats,
    handleSubmitVendor,
    handleSubmitVendorRequest,
    handleSubmitCityVendorRequest,
    handleSubmitchannelpartner,
    handleOnDrop,
    countryRef,
    country,
    setCountry,
    zone,
    setZone,
    handleSubmitCountry,
    languageRef,
    isDisabled,
    taxRef,
    currencyRef,
    currentPage,
    soldRef,
    soldAirportRef,
    handleSubmitSold,
    handleSubmitSoldAirport,
    handleSubmitBillApproval,
    handleSubmitBillDetailsPayment,
    handleSubmitSales,
    handleSubmitRevenueReport,
    handleSubmitParking,
    handleSubmitWhatsapp,
    SalesRef,
    RevenueReportRef,
    ParkingRef,
    seoVirtualRef,
    handleSubmitSeoVirtual,
    handleSubmitNews,
    handleSubmitminDuration,
  };
};

export default useFilter;
